export const createEmployeeOptions = (employees: Employee[] | undefined) =>
  employees?.map((employee) => ({
    value: employee.id,
    label: employee.name,
    employee,
  })) || [];
